import React, { useEffect } from 'react';
import "@/App.css";
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Stats from './components/Stats';
import ClientBrands from './components/ClientBrands';
import Services from './components/Services';
import Testimonials from './components/Testimonials';
import Blog from './components/Blog';
import Contact from './components/Contact';
import Footer from './components/Footer';
import BlogPost from './components/BlogPost';
import CookieConsent from './components/CookieConsent';
import LegalPage from './components/legal/LegalPage';
import { LEGAL_DOCS } from './data/legal';
import { shouldBlockKey } from './utils/blockShortcuts';

// Component to handle hash scrolling
function ScrollToHash() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    } else if (location.pathname === '/') {
      window.scrollTo(0, 0);
    }
  }, [location.hash, location.pathname]);

  return null;
}

// Disable right-click context menu and devtools shortcuts globally
const preventContextMenu = (e) => e.preventDefault();
const preventBlockedKeys = (e) => {
  if (shouldBlockKey(e)) e.preventDefault();
};

function DisableRightClick() {
  useEffect(() => {
    document.addEventListener('contextmenu', preventContextMenu);
    document.addEventListener('keydown', preventBlockedKeys);
    return () => {
      document.removeEventListener('contextmenu', preventContextMenu);
      document.removeEventListener('keydown', preventBlockedKeys);
    };
  }, []);
  return null;
}

// Home page component
function HomePage() {
  return (
    <>
      <Navbar />
      <Hero />
      <About />
      <Stats />
      <ClientBrands />
      <Services />
      <Testimonials />
      <Blog />
      <Contact />
      <Footer />
    </>
  );
}

// Blog post page component with Navbar and Footer
function BlogPostPage() {
  return (
    <>
      <Navbar />
      <BlogPost />
      <Footer />
    </>
  );
}

function LegalLayout({ doc }) {
  return (
    <>
      <Navbar />
      <LegalPage doc={doc} />
      <Footer />
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="App bg-slate-900 min-h-screen">
          <DisableRightClick />
          <ScrollToHash />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/blog/:id" element={<BlogPostPage />} />
            {LEGAL_DOCS.map((doc) => (
              <Route key={doc.key} path={doc.path} element={<LegalLayout doc={doc} />} />
            ))}
          </Routes>
          <CookieConsent />
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
